export default class Expense {
    constructor(p1, p2, val) {
      this.person1 = p1;
      this.person2 = p2;
      this.amount = val;
    }
  }